import { FactoryProvider } from '@angular/core';
import { AskAiIntelligenceConfig, Settings } from '@mri-platform/shared/core';

export const AskAiIntelligenceConfigProvider: FactoryProvider = {
  provide: AskAiIntelligenceConfig,
  useFactory: (settings: Settings) => new AskAiIntelligenceConfig(settings.askAgoraIntelligence),
  deps: [Settings]
};
